module.exports = __webpack_public_path__ + "static/media/leaf-icon_2x.55e57690.png";